import React, { useRef } from 'react'
import ClickableImageCard from '../custom-components/ClickableImageCard';
import './FF.css'

function FullyFramed() {
    const carouselRef = useRef(null);
        
    const scroll = (direction) => {
        const scrollAmount = 300;
        carouselRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
        });
    };

    const deals = [
        {id: 1, ff: "one", image: "https://assets.tatacliq.com/medias/sys_master/images/63588846895134.png"},
        {id: 2, ff: "two", image: "https://assets.tatacliq.com/medias/sys_master/images/63588846960670.png"},
        {id: 3, ff: "three", image: "https://assets.tatacliq.com/medias/sys_master/images/63588847026206.png"},
        {id: 4, ff: "four", image: "https://assets.tatacliq.com/medias/sys_master/images/63588847157278.png"},
        {id: 5, ff: "five", image: "https://assets.tatacliq.com/medias/sys_master/images/63588847222814.png"},
        {id: 6, ff: "six", image: "https://assets.tatacliq.com/medias/sys_master/images/63588847288350.png"},
    ];


    return (
        <div className="carousel-container">
          <div className="carousel-controls justify-content-end mb-5">
              <button onClick={() => scroll('left')} className="control-button">
                &lt;
              </button>
              <button onClick={() => scroll('right')} className="control-button">
                &gt;
              </button>
            </div>
          
          <div className="image-carousel" ref={carouselRef}>
            {deals.map((deal) => (
              <ClickableImageCard key={deal.id} item={deal} />
            ))}
          </div>
        </div>
      );
}

export default FullyFramed